// extracted by mini-css-extract-plugin
module.exports = {"wizard-header":"Header_wizard-header__38dRZ","title":"Header_title__24IbW"};